import { getCoreRowModel, useReactTable } from '@tanstack/react-table';
export function useDataTable({ columns, data, sorting, pagination, pageCount, onSortingChange, onPaginationChange, rowSelection, onRowSelectionChange, getRowId, enableRowSelection = true, }) {
    return useReactTable({
        columns,
        data,
        getRowId,
        state: {
            sorting,
            pagination,
            ...(rowSelection !== undefined && { rowSelection }),
        },
        onSortingChange,
        ...(onRowSelectionChange && { onRowSelectionChange }),
        onPaginationChange,
        enableRowSelection,
        manualSorting: true,
        manualPagination: Boolean(pagination),
        pageCount,
        autoResetAll: false,
        getCoreRowModel: getCoreRowModel(),
    });
}
//# sourceMappingURL=useDataTable.js.map